<app-store-page-header></app-store-page-header>
<div class="mx-auto content" *ngIf="!customerAuthService.isUserLoggedIn()">
    <div class="message">
        {{'public.checkout.loginToContinue' | translate}}
    </div>
    <app-customer-login></app-customer-login>
</div>